import {cx} from "@emotion/css";

import  {classCombinerFromPrefix}  from "@/app/pages/upik/resources/RenderIdentifier";
import SearchTabsStyles from "@/app/pages/upik/styles/SearchTabsStyles.module.scss";
import React from "react";

const styles = SearchTabsStyles;
const classCombiner = classCombinerFromPrefix("6e1124ea8c05f948");

interface HeadingContentInterface {
    content: string;
    heading: string;
}

const HeadingContent = (headingContentData: HeadingContentInterface): JSX.Element => {
    const {
        content,
        heading
    } = headingContentData;
    return (
        <>
            <div
                className={cx(classCombiner(styles, "headingClass"))}
                dangerouslySetInnerHTML={{"__html": heading}}
            />

            <div
                className={cx(classCombiner(styles, "subHeadingClass"))}
                dangerouslySetInnerHTML={{"__html": content}}
            />
        </>
    );
};
export {HeadingContent};
